
import { call, put, takeLatest } from 'redux-saga/effects';
import { getProductDetail, trackProduct } from '@/api/products';
import {
  fetchProductRequest,
  fetchProductSuccess,
  fetchProductFailure,
  trackProductRequest,
  trackProductSuccess,
  trackProductFailure,
} from '../slices/productSlice';
import { ProductDetail } from '@/types/product';
import { toast } from '@/hooks/use-toast';

function* fetchProductSaga(action: ReturnType<typeof fetchProductRequest>) {
  try {
    const product: ProductDetail = yield call(getProductDetail, action.payload);
    yield put(fetchProductSuccess(product));
  } catch (error) {
    yield put(fetchProductFailure(error instanceof Error ? error.message : 'Failed to fetch product'));
  }
}

function* trackProductSaga(action: ReturnType<typeof trackProductRequest>) {
  try {
    yield call(trackProduct, action.payload);
    toast({
      title: "Success",
      description: "Product tracked successfully.",
    });
    yield put(trackProductSuccess());
  } catch (error) {
    yield put(trackProductFailure(error instanceof Error ? error.message : 'Failed to track product'));
  }
}

export function* productSaga() {
  yield takeLatest(fetchProductRequest.type, fetchProductSaga);
  yield takeLatest(trackProductRequest.type, trackProductSaga);
}
